import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { Login } from '@df/session/login/login.interfaces';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { InputWrapBodyDirective } from 'projects/app-default/src/app/ui/form/input-wrap-body.directive';
import { InputWrapComponent } from 'projects/app-default/src/app/ui/form/input-wrap.component';
import { FormWizardStepAbstract } from '../../../../../ui/form/wizard/step/form-wizard-step.abstract';
import { NLoginForm } from '../../../login-form.interface';
@Component({
    selector: 'login-form-trade-step-3',
    templateUrl: './login-form-trade-step-3.component.html',
    standalone: true,
    imports: [FormsModule, TranslationModule, InputWrapComponent, InputWrapBodyDirective, MuiInputDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormTradeStep3Component extends FormWizardStepAbstract {
    @Input()
    data: Login.IRegisterFormData;
    get premisesOptions(): NLoginForm.PremisesOptions[] {
        switch (this.app.dfConfig.environment) {
            case 'uat':
                return NLoginForm.PREMISES_OPTIONS_UAT;
            default:
                return NLoginForm.PREMISES_OPTIONS_DEVELOPMENT;
        }
    }
    keydownHandle(event: KeyboardEvent) {
        const deleteCode = 8;
        const backspaceCode = 46;
        const key = event.keyCode || event.which;
        if (key !== deleteCode && key !== backspaceCode && !/[0-9]/.test(event.key)) {
            return false;
        }
        return true;
    }
}
